export const searchResultLightTheme = {
  '--search-result-bgc-1': '#f8f8f8',
  '--search-result-bgc-2': '#eee',
  '--search-result-bgc-3': '#9fa7b3',
  '--search-result-bgc-4': '#fff',
  '--search-result-bgc-5': '#373c45',
  '--search-result-font-c-1': '#333',
  '--search-result-font-c-2': '#fff',
  '--search-result-font-c-3': '#333',
  '--search-result-font-c-4': '#65d5ff',
  '--search-result-font-c-5': '#666',
  '--search-result-border-c-1': '#3b3e49',
}
export const searchResultDarkTheme = {
  '--search-result-bgc-1': '#23262f',
  '--search-result-bgc-2': '#23262f',
  '--search-result-bgc-3': 'rgba(255, 255, 255, 0.75)',
  '--search-result-bgc-4': '#141417',
  '--search-result-bgc-5': '#373c45',
  '--search-result-font-c-1': '#fff',
  '--search-result-font-c-2': '#fff',
  '--search-result-font-c-3': '#9fa7b3',
  '--search-result-font-c-4': '#65d5ff',
  '--search-result-font-c-5': '#b6bfc3',
  '--search-result-border-c-1': '#3b3e49',
}
